/**
 * Min 500 Add to Box - Interactive Bottom Bar Logic
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'min_500_box_items';
  const TARGET_AMOUNT = 500;

  class Min500BoxManager {
    constructor() {
      this.targetAmount = TARGET_AMOUNT;
      this.initElements();
      this.bindEvents();
      this.render();
    }

    initElements() {
      this.barEl = document.getElementById('Min500BottomBar');
      this.progressBarEl = document.getElementById('Min500ProgressBar');
      this.statusTextEl = document.getElementById('Min500StatusText');
      this.subTextEl = document.getElementById('Min500SubText');
      this.itemsListEl = document.getElementById('Min500ItemsList');
      this.cartBtnEl = document.getElementById('Min500CartBtn');
    }

    getItems() {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
      } catch (e) {
        console.error('Error reading min 500 box items:', e);
        return [];
      }
    }

    saveItems(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch (e) {
        console.error('Error saving min 500 box items:', e);
      }
      this.render();
    }

    addItem(newItem) {
      const items = this.getItems();
      const existingIndex = items.findIndex(
        (item) => String(item.id) === String(newItem.id)
      );

      if (existingIndex > -1) {
        items[existingIndex].quantity += newItem.quantity || 1;
      } else {
        items.push({
          id: String(newItem.id),
          title: newItem.title || 'Product',
          price: parseFloat(newItem.price) || 0,
          image: newItem.image || '',
          quantity: newItem.quantity || 1,
        });
      }

      this.saveItems(items);
    }

    removeItem(id, removeAll = false) {
      let items = this.getItems();
      const existingIndex = items.findIndex((item) => String(item.id) === String(id));
      if (existingIndex > -1) {
        if (!removeAll && items[existingIndex].quantity > 1) {
          items[existingIndex].quantity -= 1;
        } else {
          items.splice(existingIndex, 1);
        }
      }
      this.saveItems(items);
    }

    clearBox() {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        console.error('Error clearing min 500 box:', e);
      }
      this.render();
    }

    calculateTotal(items) {
      return items.reduce((total, item) => total + item.price * item.quantity, 0);
    }

    formatMoney(amount) {
      const currencySymbol =
        window.Shopify && window.Shopify.currency && window.Shopify.currency.active
          ? window.Shopify.currency.active === 'INR'
            ? '₹'
            : window.Shopify.currency.active + ' '
          : '₹';
      return `${currencySymbol}${amount.toFixed(2)}`;
    }

    render() {
      if (!this.barEl) {
        this.initElements();
        if (!this.barEl) return;
      }

      const items = this.getItems();
      const total = this.calculateTotal(items);
      const percentage = Math.min(100, Math.max(0, (total / this.targetAmount) * 100));

      // 1. Show or hide bottom bar
      if (items.length > 0) {
        this.barEl.classList.add('is-visible');
      } else {
        this.barEl.classList.remove('is-visible');
      }

      // 2. Update progress bar line and dynamic stage color instantly
      if (this.progressBarEl) {
        this.progressBarEl.style.width = `${percentage}%`;
        this.progressBarEl.className = 'min500-progress-bar';

        if (percentage >= 100) {
          this.progressBarEl.classList.add('stage-complete');
        } else if (percentage >= 66) {
          this.progressBarEl.classList.add('stage-high');
        } else if (percentage >= 33) {
          this.progressBarEl.classList.add('stage-mid');
        } else {
          this.progressBarEl.classList.add('stage-low');
        }
      }

      // 3. Update status text
      if (this.statusTextEl) {
        if (total >= this.targetAmount) {
          this.statusTextEl.innerHTML = `<span class="amount-success">🎉 Minimum Target Reached (${this.formatMoney(total)})</span>`;
        } else {
          const needed = this.targetAmount - total;
          this.statusTextEl.innerHTML = `<span>Box Total: <strong>${this.formatMoney(total)}</strong> / ${this.formatMoney(this.targetAmount)} (Add <span class="amount-needed">${this.formatMoney(needed)}</span> more)</span>`;
        }
      }

      if (this.subTextEl) {
        if (total >= this.targetAmount) {
          this.subTextEl.textContent = 'Ready to add all items to cart!';
        } else {
          const totalQty = items.reduce((sum, item) => sum + item.quantity, 0);
          this.subTextEl.textContent = `${totalQty} item${totalQty === 1 ? '' : 's'} in box`;
        }
      }

      // 4. Render item chips instantly
      if (this.itemsListEl) {
        if (items.length === 0) {
          this.itemsListEl.innerHTML = '';
        } else {
          this.itemsListEl.innerHTML = items
            .map(
              (item) => `
            <div class="min500-item-chip" data-id="${item.id}">
              ${item.image ? `<img src="${item.image}" alt="${item.title}" class="min500-chip-img" />` : ''}
              <div class="min500-chip-details">
                <span class="min500-chip-title" title="${item.title}">${item.title}</span>
                <span class="min500-chip-price">${item.quantity > 1 ? `${item.quantity}×` : ''}${this.formatMoney(item.price)}</span>
              </div>
              <button type="button" class="min500-remove-btn" data-remove-id="${item.id}" title="Remove item">✕</button>
            </div>
          `
            )
            .join('');
        }
      }

      // 5. Update cart button state
      if (this.cartBtnEl) {
        const btnTextEl = this.cartBtnEl.querySelector('.btn-text');
        if (total >= this.targetAmount) {
          this.cartBtnEl.disabled = false;
          this.cartBtnEl.classList.add('is-active');
          if (btnTextEl) btnTextEl.textContent = 'Add to Cart';
        } else {
          this.cartBtnEl.disabled = true;
          this.cartBtnEl.classList.remove('is-active');
          const needed = this.targetAmount - total;
          if (btnTextEl) btnTextEl.textContent = `Add to Cart (Need ${this.formatMoney(needed)} more)`;
        }
      }
    }

    bindEvents() {
      // Document level event delegation - guarantees events are captured regardless of render timing
      document.addEventListener('click', (e) => {
        // Master Add to Cart button handler
        const cartBtn = e.target.closest('#Min500CartBtn');
        if (cartBtn) {
          e.preventDefault();
          e.stopPropagation();
          if (!cartBtn.disabled && !cartBtn.classList.contains('is-loading')) {
            this.submitBoxToCart();
          }
          return;
        }

        // Remove item button handler (instant feedback)
        const removeBtn = e.target.closest('[data-remove-id]');
        if (removeBtn) {
          e.preventDefault();
          const chip = removeBtn.closest('.min500-item-chip');
          if (chip) chip.classList.add('removing');
          const id = removeBtn.getAttribute('data-remove-id');
          this.removeItem(id, e.shiftKey);
          return;
        }

        // Add to Box button handler
        const addBoxBtn = e.target.closest('[data-add-to-box-btn]');
        if (addBoxBtn) {
          e.preventDefault();
          this.handleAddBoxClick(addBoxBtn);
          return;
        }
      });

      // Storage event listener for multi-tab/window instant syncing
      window.addEventListener('storage', (e) => {
        if (e.key === STORAGE_KEY) {
          this.render();
        }
      });
    }

    handleAddBoxClick(btn) {
      const container =
        btn.closest('form') ||
        btn.closest('.product-form') ||
        btn.closest('.product') ||
        btn.closest('.card-wrapper') ||
        document;

      let variantId = null;
      // First check for active hidden input [name="id"] in form
      const idInput = container.querySelector('[name="id"]');
      if (idInput && idInput.value && !idInput.disabled) {
        variantId = idInput.value;
      }
      if (!variantId) {
        variantId = btn.getAttribute('data-variant-id');
      }

      if (!variantId) {
        console.error('Could not find variant ID for Add to Box button.');
        return;
      }

      let title = btn.getAttribute('data-product-title') || '';
      if (!title && container) {
        const titleEl = container.querySelector('.product__title, .card__heading, h1, h2');
        if (titleEl) title = titleEl.textContent.trim();
      }

      let price = parseFloat(btn.getAttribute('data-product-price'));
      if (isNaN(price) && container) {
        const priceEl = container.querySelector('.price-item--sale, .price-item--regular, .price-item');
        if (priceEl) {
          const rawPrice = priceEl.textContent.replace(/[^0-9.]/g, '');
          price = parseFloat(rawPrice);
        }
      }

      let image = btn.getAttribute('data-product-image') || '';
      if (!image && container) {
        const imgEl = container.querySelector('img');
        if (imgEl) image = imgEl.src;
      }

      let quantity = 1;
      if (container) {
        const qtyInput = container.querySelector('[name="quantity"]');
        if (qtyInput) quantity = parseInt(qtyInput.value, 10) || 1;
      }

      this.addItem({
        id: variantId,
        title: title || 'Product',
        price: isNaN(price) ? 0 : price,
        image: image,
        quantity: quantity,
      });

      // Instant visual feedback on button
      const originalText = btn.innerHTML;
      btn.innerHTML = '<span>Added to Box! ✓</span>';
      btn.classList.add('added');
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.classList.remove('added');
      }, 1200);
    }

    async submitBoxToCart() {
      const items = this.getItems();
      if (items.length === 0) return;

      const total = this.calculateTotal(items);
      if (total < this.targetAmount) return;

      this.initElements();
      if (this.cartBtnEl) {
        this.cartBtnEl.classList.add('is-loading');
        this.cartBtnEl.disabled = true;
      }

      const cartItems = items.map((item) => ({
        id: parseInt(item.id, 10),
        quantity: parseInt(item.quantity, 10) || 1,
      }));

      try {
        let addUrl = '/cart/add.js';
        if (window.routes && window.routes.cart_add_url) {
          addUrl = window.routes.cart_add_url;
          if (!addUrl.endsWith('.js') && !addUrl.endsWith('.json')) {
            addUrl = addUrl + '.js';
          }
        }

        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ items: cartItems }),
        });

        if (response.ok) {
          // Clear box upon successful cart addition
          this.clearBox();

          // Redirect directly to cart page so user sees all items in cart immediately
          const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          window.location.href = cartUrl;
        } else {
          const errData = await response.json();
          alert(`Error adding items to cart: ${errData.description || errData.message || 'Please try again.'}`);
        }
      } catch (err) {
        console.error('Failed to submit box to cart:', err);
        // Fallback redirect to cart page
        const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        window.location.href = cartUrl;
      } finally {
        if (this.cartBtnEl) {
          this.cartBtnEl.classList.remove('is-loading');
          this.cartBtnEl.disabled = false;
        }
      }
    }
  }

  // Global capturing-phase event listeners to block any checkout attempt if min-500 warning is visible
  document.addEventListener('click', function (e) {
    const checkoutBtn = e.target.closest('#checkout, #CartDrawer-Checkout, [name="checkout"]');
    if (checkoutBtn) {
      const warning = document.querySelector('.cart-min-500-warning');
      if (warning) {
        e.preventDefault();
        e.stopPropagation();
        alert('⚠️ Minimum ₹500 value required for tagged items in your box before checkout.');
        return false;
      }
    }
  }, true);

  document.addEventListener('submit', function (e) {
    const form = e.target;
    const submitter = e.submitter;
    const isCheckoutSubmit = (submitter && submitter.name === 'checkout') || (form && form.action && form.action.includes('/cart'));
    if (isCheckoutSubmit && document.querySelector('.cart-min-500-warning')) {
      e.preventDefault();
      e.stopPropagation();
      alert('⚠️ Minimum ₹500 value required for tagged items in your box before checkout.');
      return false;
    }
  }, true);

  // Initialize on DOM ready or immediately if DOM is ready
  function initMin500Box() {
    if (!window.Min500Box) {
      window.Min500Box = new Min500BoxManager();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMin500Box);
  } else {
    initMin500Box();
  }
})();
